<template>
  <div>
    <PageAllow controller="Suppliers" action="view" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
            <v-card-title class="mx-3">
              {{ $t("My.title") }}
            </v-card-title>
        <v-divider />
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <!-- 供应商编号 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.supplier_code") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  {{ my.supplier_code }}
                </v-col>
              </v-row>
              <!-- 供应商名称 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.supplier_name") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  {{ my.supplier_name }}
                </v-col>
              </v-row>
              <!-- 供应商类型 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.supply_type") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  {{ my.supply_type }}
                </v-col>
              </v-row>
              <!-- 供应商分组 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.supply_group") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  {{ my.district ? my.district.name : "" }}
                </v-col>
              </v-row>
              <!-- 供应商地址 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.supply_address") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <CitiesSelectGroup
                    :shopDetail="my"
                    @provinceSelected="my.province_id = $event.id"
                    @citySelected="my.city_id = $event.id"
                    @districtSelected="my.area_id = $event.id"
                  />
                  <v-text-field
                    single-line
                    v-model="my.address"
                    :label="$t('My.Fields.address', [''])"
                  >
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- 负责人 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.manager_name") + $t("Global.colon") }}
                  <!-- <Required  /> -->
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('My.Fields.manager_name')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="my.manager_name"
                      :hint="$t('My.managerNameHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'manager_name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <!-- <v-col cols="9" md="7" v-else>
                  {{ supplier.manager_name }}
                </v-col> -->
              </v-row>
              <!-- Email地址 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.email_address") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field single-line v-model="my.email">
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- 联系方式 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.tel_number") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('My.Fields.tel_number')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="my.manager_tel"
                      :hint="$t('My.managerTelHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'manager_tel')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 开户行 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.bank") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field single-line v-model="my.bank">
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- 账户名称 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.account_name") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field single-line v-model="my.account_name">
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- 账户号 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.account_number") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field single-line v-model="my.account_num">
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- 税号 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.tax") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field single-line v-model="my.tax_num">
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- 登陆ID -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.login") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('My.Fields.login')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-if="my && my.account_user"
                      v-model="my.account_user.account_user_id"
                      :hint="$t('My.loginUserNameHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(
                            serverErrors,
                            'account_user.account_user_id'
                          )
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 登陆密码 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.password") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field single-line v-model="my.account_password">
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- 营业执照 （单图）-->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.business_license") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-card v-if="my_img" max-width="240">
                    <v-img :src="my_img" @click.stop="imgClick()">
                      <v-tooltip right v-if="my_img">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="secondary"
                            class="pa-2 float-right"
                            @click.stop="
                              !my_img.startsWith('data:image/') &&
                              my_img == my.my_img
                                ? (my.my_img = my_img = null)
                                : (my_img = null)
                            "
                          >
                            fa-times
                          </v-icon>
                        </template>
                        <span> {{ $t("My.delImg") }}</span>
                      </v-tooltip>
                    </v-img>
                  </v-card>
                  <v-file-input
                    id="file"
                    ref="my_img_file"
                    show-size
                    prepend-icon="fa-camera"
                    accept="image/png, image/jpeg"
                    persistent-hint
                    :placeholder="$t('My.imgPlaceholder')"
                    :hint="$t('My.imgHint')"
                    :rules="imgRules"
                    v-model="my_img_file"
                    hide-input
                    style="display: none"
                  >
                  </v-file-input>
                  <v-btn
                    style="margin-top: 15px"
                    @click.stop="imgClick()"
                    color="info"
                  >
                    上传图片
                  </v-btn>
                </v-col>
              </v-row>
              <!-- 其他 （多图）-->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("My.Fields.other") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-card height="320">
                    <v-carousel hide-delimiters cycle height="320">
                      <v-carousel-item
                        v-for="(item, i) in my_album"
                        :key="i"
                        :src="item"
                        @click.stop="$showFullscreenImages(my_album, i)"
                      >
                        <v-tooltip right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              color="secondary"
                              class="pa-2 float-right"
                              @click.stop="removeFromImages(i)"
                            >
                              fa-times
                            </v-icon>
                          </template>
                          <span> {{ $t("My.delImg") }}</span>
                        </v-tooltip>
                      </v-carousel-item>
                    </v-carousel>
                  </v-card>
                  <v-file-input
                    ref="my_imgs_file"
                    show-size
                    counter
                    small-chips
                    multiple
                    suffix
                    prepend-icon="fa-camera"
                    accept="image/png, image/jpeg"
                    persistent-hint
                    :placeholder="$t('My.imgsPlaceholder')"
                    :hint="$t('My.imgsHint')"
                    :rules="imgsRules"
                    v-model="my_imgs_file"
                  >
                  </v-file-input>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn color="success" block @click="submit()">
                {{ $t("My.submit") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import My from "@/api/my";
import Files from "@/api/files";
import CitiesSelectGroup from "@/components/plugins/CitiesSelects";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    CitiesSelectGroup,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    supplier_id() {
      return this.accountUser ? this.accountUser.supplier_id : null;
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.my"),
        disabled: true,
        href: "/my",
      },
    ],
    ...mapState(["accountUser", "accountInfo","loading"]),
  },

  data: () => ({
    panelsDetail: [0],
    my_img_file: null,
    my_album: [],
    my_imgs_file: [],
    my_img: "",
    imgRules: [
      (value) => !value || value.size < 10000000 || i18n.t("My.imgHint"),
    ],
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 10000000).length == 0 ||
        i18n.t("My.imgsHint"),
    ],
    serverErrors: [],
    my: {},
    supplier: {},
  }),

  watch: {
    accountUser: {
      handler() {
        if (this.accountUser && this.accountUser.supplier_id) {
          this.id = this.accountUser.supplier_id;
          My.fetchOne(this.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.my = response.data.supplier;
                this.my_album = this.my.attachment_url;
                this.my_img = this.my.business_license_url;
              }
            }.bind(this)
          );
        }
      },
    },

    my_album: {
      handler() {
        // console.log('album',this.my_album);
      },
    },

    my_img_file: {
      handler() {
        if (this.my_img_file) {
          var reader = new FileReader();
          reader.readAsDataURL(this.my_img_file);
          let that = this;
          reader.onload = function () {
            that.my_img = this.result;
          };
        } else {
          this.my_img = this.my.my_img;
        }
      },
    },

    my_imgs_file: {
      handler() {
        if (this.my_imgs_file) {
          this.my_album = this.my.attachment_url
            ? JSON.parse(JSON.stringify(this.my.attachment_url))
            : [];
          this.my_imgs_file.forEach((img, i) => {
            var reader = new FileReader();
            reader.readAsDataURL(img);
            let that = this;
            reader.onload = function () {
              that.my_album.splice(
                (that.my.my_album ? that.my.my_album.length : 0) + i,
                0,
                this.result
              );
            };
          });
        }
      },
    },
  },

  methods: {
    imgClick() {
      document.querySelector("#file").click();
    },
    removeFromImages(i) {
      this.my_album.splice(i, 1);
      if (this.my.my_album && i < this.my.my_album.length) {
        this.my.my_album.splice(i, 1);
      } else {
        this.my_imgs_file.splice(
          i - (this.my.my_album ? this.my.my_album.length : 0),
          1
        );
      }
    },

    submit() {
      if (this.$refs.my_img_file.hasError || this.$refs.my_imgs_file.hasError)
        return;
      this.serverErrors = []; //重置远端错误提示
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            this.$store.dispatch("fullscreenLoading");
            // 先提交单图
            if (this.my_img_file) {
              let response = await Files.imageUpload(this.my_img_file, true);
              if (response.data.status.isOK()) {
                // console.log("my_img",response);
                this.my.business_license = response.data.data.img_name;
                // console.log(this.my.business_license);

                this.my.thumbnail = response.data.data.thumbnail;
              }
            }
            // 再提交多图
            if (this.my_imgs_file && this.my_imgs_file.length > 0) {
              let response = await Files.imagesUpload(this.my_imgs_file, false);
              if (response.data.status.isOK()) {
                // console.log("my_imgs_file:",response);
                if (!this.my.my_album) this.my.attachment = [];
                response.data.data.forEach((e) =>
                  this.my.attachment.push(e.img_name)
                );
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
            // 提交信息
            if (this.my.account_user) {
              this.my.account_user_id = this.my.account_user.account_user_id;
            }
            delete this.my.district;
            delete this.my.account_user;
            delete this.my.account_id;
            delete this.my.login_user_id;
            delete this.my.password;

            My.save(this.id, this.my)
              .then(
                function (response) {
                  // console.log(this.my);
                  if (response.data.status.isOK()) {
                    this.$emit("save", this.my);
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                  window.location.href = "/#/home";
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          }
        }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>